import { Breadcrumbs, Typography } from '@mui/material';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import QuoteForm from './QuoteForm';

function RegisterQuotePage() {
    const navigate = useNavigate();

    return (
        <div>
            <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" onClick={() => navigate('/admin')} to="/admin">
                    Dashboard
                </Link>
                <Link color="inherit" onClick={() => navigate('/admin/quotes')} to="/admin/quotes">
                    Orçamentos
                </Link>
                <Typography color="text.primary">Novo orçamento</Typography>
            </Breadcrumbs>
            <br />
            <Typography variant="h4" gutterBottom>Novo orçamento</Typography>
            <QuoteForm mode="create" />
        </div>
    );
}

export default RegisterQuotePage;
